(() => {
  'use strict';
  const assets = window.VicinityVirtualAssets;
  if (!assets?.catalog || !assets?.collections) return;
  let started = false;
  const loadScript = src => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  const start = () => {
    if (started) return;
    started = true;
    loadScript(assets.catalog)
      .then(() => loadScript(assets.collections))
      .catch(error => console.warn('Vicinity virtual catalog failed to load', error));
  };
  const target = document.querySelector('[data-virtual-products], [data-virtual-collection], [data-virtual-colorways], [data-virtual-look-items]');
  if ('IntersectionObserver' in window && target) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        observer.disconnect();
        start();
      }
    }, { rootMargin: '0px' });
    observer.observe(target);
  }
  if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 4500 });
  else setTimeout(start, 3500);
  ['pointerdown','keydown','touchstart'].forEach(type => window.addEventListener(type, start, { once: true, passive: true }));
})();
